import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import ClientDetails from '@/components/ClientsPage/ClientDetails';
import ClientForm from '@/components/ClientsPage/ClientForm';
import ClientFullDetails from '@/components/ClientsPage/ClientFullDetails';
import ClientList from '@/components/ClientsPage/ClientList';
import ClientSummary from '@/components/ClientsPage/ClientSummary';
import ClientUsers from '@/components/ClientsPage/ClientUsers';
import CreateUser from '@/components/ClientsPage/CreateUser';
import PackagePurchase from '@/components/ClientsPage/PackagePurchase';
import UpdateUserPermissions from '@/components/ClientsPage/UpdateUserPermissions';
import Section from '@/components/Page/Section';

const ClientsPage = () => (
  <>
    <Section cols={6}>
      <Routes>
        <Route path="/" element={<Navigate to="enabled" replace />} />
        <Route path="new" element={<ClientList />} />
        <Route path=":status/*" element={<ClientList />} />
      </Routes>
    </Section>
    <Section cols={6}>
      <Routes>
        <Route path="new" element={<ClientForm action="new" />} />
        <Route path=":status/:id/edit" element={<ClientForm action="edit" />} />
        <Route path=":status/:id/details" element={<ClientFullDetails />} />
        <Route path=":status/:id/packages" element={<PackagePurchase />} />
        <Route path=":status/:id/summary" element={<ClientSummary />} />
        <Route path=":status/:id/users/:userId/edit" element={<UpdateUserPermissions />} />
        <Route path=":status/:id/users/new" element={<CreateUser />} />
        <Route path=":status/:id/users" element={<ClientUsers />} />
        <Route path=":status/:id" element={<ClientDetails />} />
      </Routes>
    </Section>
  </>
);

export default ClientsPage;
